import { Box, Paper } from '@mui/material';
import { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import DatePickerEx from '../../components/Comman/DatePickerEx';
import { LabelCompo } from '../../components/Comman/Label';
import LandingScreenHeader from '../../components/Comman/LandingScreenHeader';
import {
  getDashboardDriverManagement,
  getDashboardStockManagement,
  getVanDashboardChallanManagement,
  getVanDashboardChallanSettlement,
  getVanDashboardSummary,
} from '../../Slice/vanStockTransfer.slice';
import {
  formatPickerDateForApi,
  getDefaultDatePickerValue,
  getMaxDateForDatePicker,
} from '../../utils/dateFormat';
import { showNotification } from '../Landing/Landing.slice';
import { useCharts } from './hooks/useCharts';
import { useDashboardData } from './hooks/useDashboardData';
import { useInjectStyles } from './hooks/useInjectStyles';
import {
  ChallanSection,
  DriverSection,
  SettlementSection,
  StockTransferSection,
  SummarySection,
} from './sections/DashboardSections';

function VanManagementDashboard({
  showNotification,
  getVanDashboardSummary,
  getVanDashboardChallanManagement,
  getDashboardDriverManagement,
  getDashboardStockManagement,
  getVanDashboardChallanSettlement,
}) {
  const [selectedDate, setSelectedDate] = useState(getDefaultDatePickerValue);

  const formattedDate = useMemo(
    () => formatPickerDateForApi(selectedDate),
    [selectedDate],
  );

  const { dashboardData, loadingState } = useDashboardData({
    showNotification,
    getVanDashboardSummary,
    getVanDashboardChallanManagement,
    getDashboardDriverManagement,
    getDashboardStockManagement,
    getVanDashboardChallanSettlement,
    selectedDate: formattedDate,
  });

  const handleDateChange = (date) => {
    if (date) {
      setSelectedDate(date);
    }
  };

  useInjectStyles();
  useCharts(dashboardData, loadingState);

  const {
    summary,
    challanStatus,
    recentChallans,
    driverKpis,
    driverUtilization,
    driverProgress,
    stockTransferFunnel,
    pendingTransfers,
    settlementKpis,
    pendingSettlements,
  } = dashboardData;

  return (

    <Paper
    className="van-dashboard"
    sx={{
      padding: '4px 16px 8px',
      '& > div:first-of-type': { marginBottom: 0 },
    }}
    elevation={0}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 1,
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <LandingScreenHeader
          screenTitle="Van Management Dashboard"
          showTable={false}
          showBackButton={false}
          showAddButton={false}
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-end',
          flexShrink: 0,
          flexWrap: 'nowrap',
          gap: 1.5,
          pr: 1,
        }}
      >
        <LabelCompo
          className="text-black"
          style={{
            fontSize: 16,
            marginBottom: 0,
            whiteSpace: 'nowrap',
            lineHeight: 1.43,
          }}
          label="Date :"
        />
        <Box
          sx={{
            width: 160,
            '& .MuiFormControl-root': {
              marginTop: 0,
              marginBottom: 0,
            },
            '& .MuiFormHelperText-root': {
              display: 'none',
              margin: 0,
              minHeight: 0,
            },
          }}
        >
          <DatePickerEx
            value={selectedDate}
            onChange={handleDateChange}
            maxDate={getMaxDateForDatePicker()}
            errorText=""
          />
        </Box>
      </Box>
    </Box>

    <div className="layout" style={{ marginTop: 10 }}>
      <div className="main">
        <div className="content" id="content">

          <SummarySection summaryKpis={summary} loadingState={loadingState} />
          <ChallanSection
            challanStatus={challanStatus}
            recentChallans={recentChallans}
            loadingState={loadingState}
          />
          <DriverSection
            driverKpis={driverKpis}
            driverUtilization={driverUtilization}
            driverProgress={driverProgress}
            loadingState={loadingState}
          />
          <StockTransferSection
            stockTransferFunnel={stockTransferFunnel}
            pendingTransfers={pendingTransfers}
            loadingState={loadingState}
          />
          <SettlementSection
            settlementKpis={settlementKpis}
            pendingSettlements={pendingSettlements}
            loadingState={loadingState}
          />
        </div>
      </div>
    </div>

    </Paper>
  );
}

const mapDispatchToProps = {
  showNotification,
  getVanDashboardSummary,
  getVanDashboardChallanManagement,
  getDashboardDriverManagement,
  getDashboardStockManagement,
  getVanDashboardChallanSettlement,
};

export default connect(null, mapDispatchToProps)(VanManagementDashboard);
